import {request, requestLogin} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let UserController = {
    getPermission: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/my-permission`,
            method: 'GET'
        }, callback)
    },
    login: (payload, callback) => {
        return requestLogin({
            url: `${URL_API}/api/sas-school/user/public/login`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    deleteAccount: (payload, callback) => {
        return requestLogin({
            url: `${URL_API}/api/sas-school/parent/public/delete-account`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    changePassword: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/change-password`,
            method: 'POST',
            body: payload
        }, callback);
    },
    getListUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/list-user`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    searchUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/search-user`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },

    createUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/add-user-school`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    adminEditUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/admin-edit-user`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    editUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/edit-user`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detailUser: (userId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/detail-user/${userId}`,
            method: 'GET',
        }, callback);
    },
    detailSelf: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/detail-self`,
            method: 'GET',
        }, callback);
    },
    deleteUser: (uuid, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/user/delete-user/${uuid}`,
            method: 'GET'
        }, callback)
    },
}

export default UserController
